module.exports = __webpack_public_path__ + "img/play.f14a358d.svg";